export { default }from './PaymentTitleInfo';
